import type { FaireProductEntity } from "../../entity_types/product";

export const p_ud5bc5crxk: FaireProductEntity = {
  token: "p_ud5bc5crxk",
  type: "product",
  name: "Bell Sleeve Baseball Tee - White",
  brandToken: "b_41hrqq6ws3",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/23da004c25523d88fcf1f5cc37594e3015a21b4b311b85d1bb8abd9f1488f2dc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/be694ed5cf30853752ef45f3c408c9008d66786738a480f7e477e375db3246ec.jpeg",
    "https://cdn.faire.com/fastly/84db1c45df3fbc0245ee7db0a9143fda5498acd0dd48ec2459b2086be871da1b.jpeg",
    "https://cdn.faire.com/fastly/a6324086b0ad63d275693dad81af0142681f96e995b2115ad94c6dd665148a06.jpeg",
    "https://cdn.faire.com/fastly/9a7f3208c0f6f8a8e707ffb9d67ac3c97bfbd7c8e58c42d7e9167d7abd36e5a9.jpeg",
    "https://cdn.faire.com/fastly/bcf62bbd4194b9a63d7e707ca48f57ffce3621980fb004a47a396a34f1c0ac34.jpeg",
    "https://cdn.faire.com/fastly/9451f55c0d12297ad9893527cfbdafbce0be0624c4acbdc36ffa25ce35c341a1.jpeg",
  ],
  priceDollars: 33.26,
  description:
    'This is the one that has all the fun with the sweet style of a baseball tee, a roomy fit, and tiered flounce in these boho-chic bell sleeves. Soft knit is just right for this tunic length tee with side-slits and classic contrast at the crewneck band. \n\n*Due to lighting and differences in monitors, actual colors may vary slightly from what appears online.\n\nModel is 5\'8" and wearing a size small.\n\nApproximate measurements are as follows:\n\n * SMALL: Bust: 38 1/4", Length: 30 3/8", Sleeve length: 26.5 " \n * MEDIUM: Bust: 40 1/4", Length: 30 7/8", Sleeve length: 26.75" \n * LARGE: Bust: 42 1/4", Length: 31 3/8", Sleeve length: 27" \n * X-LARGE: Bust: 44 1/4", Length: 31 7/8", Sleeve length: 27.25" \n\n * 50% Cotton, 50% Modal \n * Hand wash cold, Lay flat to dry\n * Made in Mexico',
  tags: [],
  msrpDollars: 66.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:38.822Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
